import { render } from "./TabsPage.vue?vue&type=template&id=4e5471e8&scoped=true&ts=true"
import script from "./TabsPage.vue?vue&type=script&lang=ts"
export * from "./TabsPage.vue?vue&type=script&lang=ts"

import "./TabsPage.vue?vue&type=style&index=0&id=4e5471e8&scoped=true&lang=css"

import exportComponent from "/Users/rico/_repos/99v/trackyourgame/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5471e8"]])

export default __exports__